import { Injectable } from '@angular/core'
import { Poll } from '../interfaces/'
import { environment } from '../../environments/environment'
import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PollsService {

  constructor(private http: HttpClient) {}

  getAll(page = 0): Observable<Poll[]> {
    return this.http.get<Poll[]>
    (environment.baseUrlWs + environment.wsVerison + 'employer/campaigns/?type=poll&page=' + page);
  }

  create(pollForm: Object, type: string): Observable<any> {
    return this.http.post(environment.baseUrlWs + environment.wsVerison + 'employer/campaigns/' + type, pollForm);
  }

  update(postid: number, postForm: Object, status: string, type: string): Observable<any> {
    return this.http.put
    (environment.baseUrlWs + environment.wsVerison + 'employer/campaigns/' + type + '/' + postid + '/' + status, postForm);
  }


}
